import { render, staticRenderFns } from "./Checkbox.vue?vue&type=template&id=54dfbee7"
import script from "./Checkbox.ts?vue&type=script&lang=ts&external"
export * from "./Checkbox.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports